import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { AuthUser } from '@aws-amplify/auth';
import type { UserRole } from 'src/auth/auth.types';

interface AuthState {
    isAuthenticated: boolean;
    isLoading: boolean;
    user: AuthUser | null;
    error: string | null;
    roles: UserRole[];
}

const initialState: AuthState = {
    isAuthenticated: false,
    isLoading: true,
    user: null,
    error: null,
    roles: [],
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthenticated: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload;
            state.isLoading = false;
        },
        setUser: (state, action: PayloadAction<AuthUser | null>) => {
            state.user = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        setRoles: (state, action: PayloadAction<UserRole[]>) => {
            state.roles = action.payload;
        },
        resetAuth: (state) => {
            return initialState;
        }
    }
});

export const {
    setAuthenticated,
    setUser,
    setLoading,
    setError,
    setRoles,
    resetAuth
} = authSlice.actions;

// Selectors
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectIsLoading = (state: RootState) => state.auth.isLoading;
export const selectUser = (state: RootState) => state.auth.user;
export const selectAuthError = (state: RootState) => state.auth.error;
export const selectRoles = (state: RootState) => state.auth.roles;
export const selectIsAdmin = (state: RootState) => state.auth.roles.includes('admin');
export const selectIsUat = (state: RootState) => state.auth.roles.includes('uat');

export default authSlice.reducer;